import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { clerkClient } from "@/App";

export interface User {
  id: number;
  email: string;
  display_name: string;
  full_name: string;
  created_at: string;
  subscription_status: string | null;
  subscription_plan_slug: string | null;
  subscription_plan_ends_at: string | null;
}

export const useUserQuery = () => {
  return useQuery({
    queryKey: ["user", "me"],
    queryFn: async () => {
      const authToken = await clerkClient.session?.getToken();
      if (!authToken) {
        throw new Error("Authentication required");
      }
      const response = await api.get<User>("/users/me", {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      return response.data;
    },
  });
};
